import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EmpresasService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    getEmpresas() {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/empresas/listaempresas?user=${userid}`, { headers }).toPromise();
    }
    obtenerEmpresas() {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/empresas/obtener_empresas`, { headers }).toPromise();
    }
}
EmpresasService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmpresasService_Factory() { return new EmpresasService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EmpresasService, providedIn: "root" });
